'use strict';

/**
 * @param {JQueryStatic} $
 * @returns {Promise<void>}
 */
const waitForDomReady = ($) =>
	new Promise((resolve) => {
		$(() => resolve());
	});

/**
 * Starts the V5 storefront in the required lifecycle order.
 *
 * @returns {Promise<void>}
 */
export const bootstrapV5 = async () => {
	const { default: $ } = await import('jquery');

	// Runtime modules read mpro.config while they are evaluated.
	await import('@shared/config/_init-config.js');

	await waitForDomReady($);
	await import('./runtime/eager-modules.js');

	// The DOM is already ready, so delegates can run immediately.
	mpro.init({ now: true });
};
